module.exports = __webpack_public_path__ + "ce7b7c6706331a66cb32b5199418bea6.svg";